// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog__text[data-v-f1a6e7a2]{font-size:17px;margin:15px 0}", ""]);
// Exports
module.exports = exports;
